import Dexie from "dexie";
import { IExportArtifact } from "../../domain/ExportArtifacts/IExportArtifact";
import { IModelInfo } from "../../domain/ModelInfos/IModelInfo";

type ModelInfoKey = keyof IModelInfo;
type ExportArtifactKey = keyof IExportArtifact;

export class LocalDb {
    public dexie: Dexie;
    public modelInfo: Dexie.Table<IModelInfo, string>;
    public exportArtifact: Dexie.Table<IExportArtifact, string>;

    public constructor() {
        this.dexie = new Dexie("domainizr");

        const modelInfoIndexes: ModelInfoKey[] = ["id", "name", "namespace"];
        const exportArtifactIndexes: ExportArtifactKey[] = [
            "id",
            "exportId",
            "created",
            "fileName",
        ];
        this.dexie.version(1).stores({
            modelInfo: modelInfoIndexes.join(","),
            exportArtifact: exportArtifactIndexes.join(","),
        });
        this.modelInfo = this.dexie.table("modelInfo");
        this.exportArtifact = this.dexie.table("exportArtifact");
    }
}

export const localDb = new LocalDb();
